import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../styles';
import './bpm-steps.scss';
import { popupFactory } from '../pop-up/index';
import { storeFactory } from '../pop-up/store';
import bpmStepsRootReducer from '../../reducers/apps/bpm-step-root.reducer';
import { Route, Switch } from 'react-router-dom';

import BPMStepsApp from './bpm-steps-component';

// trying to make pop-up/pop-out apps simpler.
// you need
// 1. a root reducer
// 2. an app or some content.

const { store, history } = storeFactory(bpmStepsRootReducer);

const Popup = popupFactory({
  store,
  history
});

const bpmPopup = (
  <Popup>
    <Switch>
      <Route path="/" component={BPMStepsApp} />
    </Switch>
  </Popup>
);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(bpmPopup);
